export type IoLinkSensorDataMetricTypes =  'SM4000_29f_totalizer' | 'SM4000_29f_flow' | 'SM4000_29f_temperature' | 'PV8000_4be_pressure' | 'PV8000_4be_temperature' | 'TA2303_17a_temperature' | 'PV7603_356_pressure'
export const metrics = [ 'SM4000_29f_flow', 'SM4000_29f_temperature', 'PV8000_4be_pressure', 'PV8000_4be_temperature', 'TA2303_17a_temperature', 'PV7603_356_pressure']

export const metricsNew = [
  "inlet_water_cooling_2_flow",
  "inlet_water_cooling_2_temperature",
  "inlet_filtered_water_4_pressure",
  "inlet_filtered_water_4_temperature",
  "hydraulic_main_oil_8_pressure",
  "hydraulic_main_oil_8_temperature",
  "oil_tank_1_temperature",
  "high_water_pressure"
];
